<template>
  <Section>
    <template #header>
      <div class="mr-auto">
        <strong>Notes</strong>
      </div>
      <div>
        <NotesDialog :lead="lead"/>
      </div>
    </template>
    <div style="white-space: pre-line">
      {{ lead.pro_notes }}
    </div>
  </Section>
</template>

<script>
import { Section } from '@/components/pages'
import NotesDialog from '../dialogs/Notes'
import { mapGetters } from 'vuex'

export default {
  name: 'LeadNotesSection',

  components: { Section, NotesDialog },

  props: {
    lead: { type: Object, required: true },
  },

  computed: {
    ...mapGetters('leads', ['currentLead']),
  },
}
</script>